var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSirapinar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "katman_1",
    "data-name": "katman 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 35 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n        stroke-width: 0px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M33,7.1c1,.2,1.8.7,1.8.7,0,0,.2,0,.2.1-.1.8-.4,1.2-.6,1.5-.3.3-.7.5-.8.9,0,0-.1.3-.1.6,0,0,0,.2,0,.3-1.3,1.2-1.4,3.1-2.6,4.5-.9,1.1-2.2,1.5-3.5,2-1.8.6-3.7,2.9-3.7,4.8,0,.7-.2,1.3-.8,1.6-.2.1-.4.2-.5.5-.2.8-.8,1.1-1.4,1.5-.7.4-1.5.7-1.6,1.7,0,.3-.3.4-.5.2-.8-.8-2.3-.8-2.6-2.1-.3-1.1-1.1-1.5-2-1.8-1.1-.4-1.5-.1-1.6,1,0,.3-.2.5-.5.5-.6,0-1.2.7-1.7,0-1.3-1.6-3-1.5-4.7-1.4-1.3,0-2.5-.2-3.4-1.2-.4-.4-.9-.8-1.3-1.2C.2,21.1,0,20.1,0,19.1c0-.4.4-.8.9-.7,2.6.2,4.6-.9,6.5-2.6.6-.6,1.3-1,2.2-.9.7,0,1.2-.3,1.5-.9.5-1,1.3-1.3,2.4-1.1.9.2,1.7.1,2.4-.6.4-.4,1-.5,1.5-.5,1.2.1,2.4-.1,3.6,0,.9,0,2,.2,3-.4.7-.4,1.7-.2,2.5-.1,1.5.2,2.8-.2,3.7-1.4.6-.8,1.5-1.2,2.1-1.9,0-.1.2-.2.3-.4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSirapinar);
export default __webpack_public_path__ + "static/media/sirapinar.97710fd7e782358455a15f7e670bf961.svg";
export { ForwardRef as ReactComponent };